import React, { useState, useEffect } from "react";
import { Form, Image } from "react-bootstrap";
import "./InputBox.css";
import { toLower } from "lodash";
import { formatDate } from "../../helpers/date-formatter";

const InputBox = (props) => {
  const [focus, setFocus] = useState(false);
  const alphanumericWithSpaceRegex = /^[a-zA-Z0-9\s]*$/;
  const alphanumericWithSpaceAmp = /^[a-zA-Z0-9\s&]*$/;
  const alphanumericWithSpaceAmpDot = /^[a-zA-Z0-9\s&.]*$/;
  const alphanumericWithSpaceAtDot = /^[a-zA-Z0-9\s@.]*$/;
  const alphanumericWithoutSpaceRegex = /^[a-zA-Z0-9]*$/;
  const alphanumericWithDashSlash = /^[a-zA-Z0-9-\\/]+$/;
  const specialCharacterRegex = /[!@#$%^&*()]/;
  const regex = /^\d{0,15}(\.\d{0,2})?$/;
  const numericRegex = /^\d*$/;
  const alphaNumericSpacewithplus = /^[a-zA-Z\d\s-+_]+$/;
  const numericDashComma = /^[0-9-,]*$/;
  const alphaWithUnderscore = /^[A-Za-z_]*$/;
  const alphaNumericSpaceDot = /^[A-Za-z\d.\s]*$/;
  const alphaNumericDashDotBracketSlash = /^[A-Za-z0-9\s./()\-]*$/;
  const alphaWithSpace = /^[A-Za-z\s]*$/;
  const alphaNumericSpaceUnderscorePercentage = /^[A-Za-z0-9\s_%]*$/;
  const alphaWithAmp = /^[A-Za-z&]*$/;
  const email = /^[a-zA-Zen0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const webAddress = /^([\w@:\\/]+(\.\w+)+)$/;
  const dateFormat = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-(19|20)\d{2}$/;
  const alphaNumericSpaceUnderscorePercentageMinus = /^[A-Za-z0-9\s_%-]*$/;
  const alphanumericWithSpaceHyphen = /^[A-Za-z0-9\s\-]*$/;
  const alphaNumericWithSpecialChars = /^[A-Za-z\d\s-.()\\/|,!#_;@$%*&:[\]]*$/;
  const DecimalNumber = /^[0-9.]*$/;
  const TimeStamp = /^[A-Za-z0-9\s:.-]*$/;
  const regexLimit = /^\d{0,20}(\.\d{0,2})?$/;


  const validateInput = () => {
    setFocus(false);
    allValidations();
  };

  const onFocused = () => {
    setFocus(true);
  }

  const validateStartDate = (date) => {
    const selectedDate = new Date(date);
    const currentDate = new Date();
    if (selectedDate > currentDate) {
      return `${(props.fieldName)} should not be greater than todays date`;
    }
    return "";
  }
  const validateEndDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const currentDate = new Date();
    // if (end < currentDate) {
    //   return "End date should be greater than today's date";
    // }
    if (end < start) {
      return "End date should be greater than start date";
    }
    return "";
  }
  const validateTargetVCRange = (rangeValue) => {
    const numericValue = parseFloat(rangeValue);
    if (numericValue < 0 || numericValue > 1.5) {
      return "Values must be in between 0 to 1.5";
    }
    return ""
  }
  const validatePercentageValue = (value) => {
    const numericValue = parseFloat(value);
    if (numericValue >= 100) {
      return "Percentage value must be less than 100";
    }
    return "";
  }
  const validateMandatory = () => {
    if (!props.value || props.value === "") {
      if (!props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields &&
          props.setMandatoryFields((prev) => [...prev, props.name]);
      }
      return `Please provide valid ${toLower(props.fieldName)}`;
    } else {
      let mandatoryFieldsTemp = props.mandatoryFields;
      if (mandatoryFieldsTemp?.length > 0) {
        const index = mandatoryFieldsTemp.indexOf(props.name);
        if (index > -1) {
          mandatoryFieldsTemp.splice(index, 1);
        }
        props.setMandatoryFields &&
          props.setMandatoryFields(mandatoryFieldsTemp);
      }
      return "";
    }
  };

  // const validateSpecialCharacters = (value) => {
  //   if (specialCharacterRegex.test(value)) {
  //     return props.fieldName + " must not contain special characters";
  //   }
  //   return "";
  // };

  const allValidations = () => {
    let errorMsg = "";

    if (props.required) {
      errorMsg = validateMandatory();
    }
    if (props.name === 'start_date') {
      errorMsg = validateStartDate(props.value)
    }
    if (props.name === 'end_date') {
      errorMsg = validateEndDate(props.startDate, props.value);
    }
    if (props.name === 'TargetVC_x0025_') {
      errorMsg = validateTargetVCRange(props.value);
    }
    if (props.type === 'date' && props.value) {
      const today = new Date().toISOString().split("T")[0];
      if (props.value < today) {
        errorMsg = `${props.fieldName} cannot be a past date`;
      }
    }
    if (props.hasOwnProperty("isPercentage") && props.value) {
      errorMsg = validatePercentageValue(props.value);
    }




    if (errorMsg) {
      props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
      return;
    } else {
      props.setError((prev) => ({ ...prev, [props.name]: "" }));
    }
    if (props.value && props.value !== "") {
      if (props.hasOwnProperty("isAlphanumeric")) {
        if (!alphanumericWithSpaceRegex.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric and space ",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphabetAmp")) {
        if (!alphaWithAmp.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphabets and &",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphanumericSpaceDot")) {
        if (!alphaNumericSpaceDot.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumberic,space and dot",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isWebAddress")) {
        if (!webAddress.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can be valid web address format",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("Email")) {
        if (!email.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can be valid email format",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaNumericDashDotBracketSlash")) {
        if (!alphaNumericDashDotBracketSlash.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric with space,-,.,(),/",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isNumberDashComma")) {
        if (!numericDashComma.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only Number,dash,comma ",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaNumericSpaceAmp")) {
        if (!alphanumericWithSpaceAmp.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric space,&",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAplhaNumricPlus")) {
        if (!alphaNumericSpacewithplus.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric space,+,-,Dot",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaNumericSpaceAmpDot")) {
        if (!alphanumericWithSpaceAmpDot.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric space,&,Dot",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaNumericSpaceAtDot")) {
        if (!alphanumericWithSpaceAtDot.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric space,@,Dot",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphanumericWithoutSpace")) {
        if (!alphanumericWithoutSpaceRegex.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain alphanumeric without space",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphanumericWithDashSlash")) {
        if (!alphanumericWithDashSlash.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain alphanumeric with dash and slash",
          }));
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isNumericWithDecimal")) {
        if (!regex.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]:
              props.fieldName +
              " can contain Numeric. Up to 2 decimal digits allowed. Max length is " + props.maxLength,
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isNumericWithDecimalLimit")) {
        if (!regexLimit.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]:
              props.fieldName +
              " can contain Numeric. Up to 2 decimal digits allowed. Max length is " + props.maxLength,
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isNumeric")) {
        if (!numericRegex.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " must be numeric",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isMobileNumber")) {
        if (props.value && !/^\d+$/.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " must be numeric",
          }));
          return;
        }
        if (props.value && props.value.length !== 10) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " should be exactly 10 digits",
          }));
          return;
        }
        props.setError((prev) => ({ ...prev, [props.name]: "" }));
      }
      if (props.hasOwnProperty("isAlphaWithUnderscore")) {
        if (!alphaWithUnderscore.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain alphabets or _ character",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaWithSpace")) {

        if (!alphaWithSpace.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain alphabets or space character",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isalphaNumericSpaceUnderscorePercentage")) {
        if (!alphaNumericSpaceUnderscorePercentage.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " must be character",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphaNumericSpaceUnderscorePercentageMinus")) {
        if (!alphaNumericSpaceUnderscorePercentageMinus.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric,space,_,%,-",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphanumericWithSpecialChars")) {
        if (!alphaNumericWithSpecialChars.test(props.value)) {
          props.setError((prev) => ({ ...prev, [props.name]: props.fieldName + ` must be alphanumeric without ^,+,{,},',",<,>,?` }));
        }
        else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isDecimalNumber")) {
        if (!DecimalNumber.test(props.value)) {
          props.setError((prev) => ({ ...prev, [props.name]: props.fieldName + " must be number" }));
        }
        else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isTimeStamp")) {
        if (!TimeStamp.test(props.value)) {
          props.setError((prev) => ({ ...prev, [props.name]: props.fieldName + " must be date" }));
        }
        else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isAlphanumericWithSpaceHyphen")) {
        if (!alphanumericWithSpaceHyphen.test(props.value)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " can contain only alphanumeric,space,-",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      if (props.hasOwnProperty("isDateFormat")) {
        const formattedDate = props.value.split('-').reverse().join('-');
        if (!dateFormat.test(formattedDate)) {
          props.setError((prev) => ({
            ...prev,
            [props.name]: props.fieldName + " must be date format",
          }));
          return;
        } else {
          props.setError((prev) => ({ ...prev, [props.name]: "" }));
        }
      }
      // errorMsg = validateSpecialCharacters(props.value);
      // if (errorMsg) {
      //   props.setError((prev) => ({ ...prev, [props.name]: errorMsg }));
      // } else {
      //   props.setError((prev) => ({ ...prev, [props.name]: "" }));
      // }
    }
  };

  useEffect(() => {
    if (
      props?.required &&
      (props.value === "" || !props.value) &&
      !props.mandatoryFields?.includes(props.name)
    ) {
      props.setMandatoryFields &&
        props.setMandatoryFields((prev) =>
          prev.includes(props.name) ? prev : [...prev, props.name]
        );
    } else if (props?.required && props.value && props.value !== "") {
      props.setMandatoryFields &&
        props.setMandatoryFields((prev) => prev.filter((f) => f !== props.name));
    }
    return () => {
      if (props?.required) {
        props.setMandatoryFields &&
          props.setMandatoryFields((prev) => prev.filter((f) => f !== props.name));
      }
    };
  }, []);

  useEffect(() => {
    if (props?.required && props.value && props.value !== "") {
      if (props.mandatoryFields?.includes(props.name)) {
        props.setMandatoryFields &&
          props.setMandatoryFields((prev) => prev.filter((f) => f !== props.name));
      }
      if (props.error) {
        props.setError && props.setError((prev) => ({ ...prev, [props.name]: "" }));
      }
    }
  }, [props.value]);

  useEffect(() => {
    if (props.submit) {
      props.setFieldCount((prev) => [...prev, props.name]);
      allValidations();
    }
  }, [props.submit]);
  // Validate percentage as user types

  const isReadOnlyDate = props.type === 'date' && props.readOnly;

  return (
    <Form.Group className={`form-group form-floating mb-3 ${props.className || ""} ${props.readOnly ? "read-only" : ""}`}>
      {isReadOnlyDate ? (
        <Form.Control
          autoComplete="off"
          type="text"
          style={props.style}
          value={props.value ? formatDate(props.value) : ""}
          onChange={() => {}}
          placeholder=" "
          className={`form-control ${props.error ? 'error' : ''}`}
          readOnly
          name={props.name}
          id={props.id}
        />
      ) : (
      <Form.Control
        autoComplete="off"
        type={props.type}
        as={props.as}
        style={props.style}
        value={props.value}
        onChange={props.onChange}
        // onInput={validateInput}
        maxLength={props.maxLength}
        placeholder={props.type === "text" && props.as === "textarea" ? (props.label || " ") : " "}
        className={`form-control ${props.error ? 'error' : ''}`}
        required={props.required}
        onBlur={validateInput}
        disabled={props.disabled}
        readOnly={props.readOnly}
        name={props.name}
        id={props.id}
        onFocus={onFocused}
        min={props.type === 'date' ? new Date().toISOString().split('T')[0] : undefined}
      />
      )}
      {!(props.type === "text" && props.as === "textarea") && (
            <Form.Label className="floating-label">{props.label}</Form.Label>
          )} 
     {props.name === "date" && (
        <Image className="calendar-btn" onClick={() => props.click()}></Image>
      )}
      {focus && !props.error && !props.readOnly && <div className="hint">{props.hint}</div>}

      {props.error && <div className="error">{props.error}{focus}</div>}

    </Form.Group>
  );
};

export default InputBox;
